var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 11.5309L10.9749 7.90824C10.792 7.77566 10.5492 7.7557 10.3487 7.85872C10.1467 7.96095 10.0205 8.16859 10.0205 8.39301V15.6359C10.0205 15.8627 10.1467 16.0696 10.3487 16.1718C10.4342 16.2149 10.5276 16.2365 10.6219 16.2365C10.7449 16.2365 10.8695 16.1973 10.9749 16.1199L15.9584 12.5004C16.1157 12.3846 16.2076 12.2057 16.2076 12.0157C16.2084 11.8224 16.1141 11.6443 15.9584 11.5309Z",
    fill: "#193847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 0.00170898C5.37167 0.00170898 0 5.37338 0 12.0021C0 18.6284 5.37167 23.9985 12.0004 23.9985C18.6275 23.9985 24 18.6276 24 12.0021C24.0008 5.37338 18.6275 0.00170898 12.0004 0.00170898ZM12.0004 21.9963C6.48018 21.9963 2.00459 17.5231 2.00459 12.0021C2.00459 6.48349 6.48018 2.0047 12.0004 2.0047C17.5198 2.0047 21.9946 6.48269 21.9946 12.0021C21.9954 17.5231 17.5198 21.9963 12.0004 21.9963Z",
    fill: "#193847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.976a00e1d21339d7fa9050c91408bf01.svg";
export { ForwardRef as ReactComponent };